module.exports = "<svg viewBox=\"0 0 35.9 35.9\"><path d=\"M17.9 0C8 0 0 8 0 17.9c0 9.9 8 17.9 17.9 17.9 9.9 0 17.9-8 17.9-17.9C35.9 8 27.9 0 17.9 0zm4.6 16.2c0-2-1.6-3.7-3.7-3.7-2 0-3.7 1.6-3.7 3.7v1.1h4.5v4.1h-4.5v6.5h-4.7V16.2c0-4.6 3.7-8.3 8.3-8.3 4.6 0 8.3 3.7 8.3 8.3h-4.5z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/facebook.svg
// module id = 280
// module chunks = 1